<template>
  <v-text-field
    v-model="inputValue"
    v-bind:rules="inputRules"
    density="compact"
    variant="outlined"
  ></v-text-field>
</template>
<script>
import validator from "@/helper/validator";
export default {
  name: "StudnetGSN",
  props: {
    modelValue: String,
  },
  data: () => ({
    inputRules: [validator.required],
  }),
  computed: {
    inputValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
};
</script>
